import { render } from "./MiniOrderList.vue?vue&type=template&id=2d8b368a&scoped=true"
import script from "./MiniOrderList.vue?vue&type=script&lang=js"
export * from "./MiniOrderList.vue?vue&type=script&lang=js"

import "./MiniOrderList.vue?vue&type=style&index=0&id=2d8b368a&lang=scss&scoped=true"

import exportComponent from "C:\\programs\\dd2.0\\dw-dwms-mini\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8b368a"]])

export default __exports__